import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { Select, MenuItem } from "@mui/material";
import { callAPI } from "../../../axios";
import { setChainIdAction } from "../../../store/actions/GetChainId/SetChainIdActions";
import { useDispatch, useSelector } from "react-redux";
import { getChainIdLS, setChainIdLS, isAutoModeViewerRoleCode, formatHotelDisplayName } from "../../../utils/utils";
import { setViewTypeAction } from "../../../store/actions/GetViewType/SetViewTypeActions";
import { Autocomplete, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

const isSelectedHotelDataChanged = (existingHotel, updatedHotel) => {
  if (!existingHotel || !updatedHotel) return true;
  return (
    existingHotel.code !== updatedHotel.code ||
    existingHotel.name !== updatedHotel.name ||
    existingHotel.viewType !== updatedHotel.viewType ||
    existingHotel.enterpriseChainId !== updatedHotel.enterpriseChainId ||
    existingHotel.testHotel !== updatedHotel.testHotel ||
    existingHotel.demoHotel !== updatedHotel.demoHotel
  );
};

const getHotelBrandSubtitle = (option) => {
  if (!option) return "";
  return option.viewType === "custom"
    ? "TP-HMS"
    : `${(option.brandDisplayName ?? "").toString()}`;
};

const SelectHotel = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const [hotelList, setHotelList] = useState([]);
  const [hotelListFlag, setHotelListFlag] = useState(false);
  const [lastSelectedHotel, setLastSelectedHotel] = useState(null);
  // const [chainId, setChainId] = useState("");
  const { control, watch, setValue } = useForm({
    defaultValues: {
      chainId: '',
    },
  });
  const selectedChainId = watch('chainId');
  const { hotelUpdateFlag } = useSelector((state) => state.updateMasterHotelReducer)
  const { chainId: reduxChainId } = useSelector((state) => state.chainIdReducer);
  const disableHotel = ((props?.userRoleCode === "ROLE_SUPER_ADMIN" && location?.pathname === "/hms/ConfigurationNewHotel") || location?.pathname === "/hms/DefaultConfig" || location?.pathname === "/hms/PartnerConfiguration" ||
    location?.pathname === "/hms/RoomTypeConfiguration" || location?.pathname === "/hms/UtilityServiceConfiguration" || location?.pathname === "/hms/fetchcdsndetails" ||
    location?.pathname === "/hms/userList" || location?.pathname === "/hms/createEditUser" || location?.pathname === "/hms/roles" || location?.pathname === "/hms/rolesPermissions" ||
    location?.pathname === "/hms/userPrivilege" || location?.pathname === "/hms/SatelliteChannelMapping" || location?.pathname === "/hms/editUser" || location?.pathname === "/hms/pending-approvals" ||
    location?.pathname === "/hms/edit-role" || location?.pathname === "/hms/create-role" || location?.pathname === "/hms/myAccount" || location?.pathname === "/hms/changePassword" ||
    location?.pathname === "/hms/APKProviderConfiguration" || location?.pathname === "/hms/SoftwareStackDetails" || location?.pathname === "/hms/Dashboard/Hotels_Dashboard" || location?.pathname === "/hms/WhitelistDomain" ||
    location.pathname === "/hms/Dashboard/Automode_Dashboard" || location.pathname === "/hms/Dashboard/AssetManagement_Dashboard" || location.pathname === "/hms/thirdPartyHotelConfiguration" ||
    location.pathname === "/hms/Dashboard/Test_Demo_Hotels_Dashboard"
  )
  const syncSelectedHotelToRedux = (selectedChainId, selectedMasterHotel) => {
    const existingHotel = reduxChainId?.navSelectedhotelName?.[0];
    const updatedHotel = selectedMasterHotel[0];

    if (!isSelectedHotelDataChanged(existingHotel, updatedHotel)) {
      return;
    }

    dispatch(setChainIdAction({
      selectedChainId,
      navSelectedhotelName: selectedMasterHotel,
    }));
  };

  useEffect(() => {
    callAPI(`master?type=HOTELS`, "GET")
      .then((response) => {
        setHotelList(response.data);
        setHotelListFlag(true);
        const currentChainId = getChainIdLS();
        const selectedMasterHotel = response?.data?.filter((item) => item.code === currentChainId);
        const viewType = response?.data?.filter((item) => item.code === currentChainId);
        if (selectedMasterHotel?.length) {
          setValue('chainId', currentChainId);
          setChainIdLS(currentChainId);
          syncSelectedHotelToRedux(currentChainId, selectedMasterHotel);
        }
        else if (response.data?.length) {
          const fallbackChainId = response.data[0].code;
          setValue('chainId', fallbackChainId);
          setChainIdLS(fallbackChainId);
          syncSelectedHotelToRedux(fallbackChainId, [response.data[0]]);
        }
        if (viewType?.length) {
          dispatch(setViewTypeAction(viewType[0]?.viewType));
        }
        else if (response.data?.length) {
          dispatch(setViewTypeAction(response.data[0].viewType));
        }
      })
      .catch((error) => console.warn(error));
  }, [hotelUpdateFlag]);

  const initialRender = useRef(true)
  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false
    }
    else {
      if(selectedChainId){
      setChainIdLS(selectedChainId);
      let viewType = hotelList.filter((item) => item?.code === selectedChainId);
      dispatch(setChainIdAction({ selectedChainId, navSelectedhotelName: viewType}));
      dispatch(setViewTypeAction(viewType[0]?.viewType));
      if (
        viewType[0]?.viewType === "hotelApp" &&
        props?.userRoleCode !== "ROLE_SUPER_ADMIN" &&
        !isAutoModeViewerRoleCode(props?.userRoleCode)
      ) {
        if (location?.pathname === "/hms/ConfigurationMasterApk") {

        }
        else {
          navigate("/hms/HotelOnboardingWizard");
        }
      }
      else if (viewType[0]?.viewType === "custom" && location?.pathname === "/hms/ConfigurationMasterApk") {
        navigate("/hms/ConfigurationNewHotel");
      }
    }
    }
  }, [selectedChainId]);

  useEffect(() => {
    if (hotelListFlag) {
      let hotelListItems = JSON.parse(
        JSON.stringify(hotelList)
      );
      let viewType = hotelListItems.filter((item) => item?.code === selectedChainId);
      dispatch(setChainIdAction({ selectedChainId, navSelectedhotelName: viewType }));
      dispatch(setViewTypeAction(viewType?.[0]?.viewType));
    }
  }, [hotelListFlag])

  return (
    <Controller
      name="chainId"
      control={control}
      render={({ field }) => (
        <Autocomplete
          options={hotelList}
          getOptionLabel={formatHotelDisplayName}
          isOptionEqualToValue={(option, value) => option?.code === value?.code}
          value={
            hotelList.find((hotel) => hotel.code === field.value) || null
          }
          onChange={(_, selectedHotel) => {
            const hotelCode = selectedHotel?.code || '';
            field.onChange(hotelCode);
            if (selectedHotel) {
              setLastSelectedHotel(selectedHotel); // update last valid
            }
          }}
          onBlur={() => {
            const selectedHotel = hotelList.find(hotel => hotel.code === field.value);
            if (!selectedHotel && lastSelectedHotel) {
              setValue('chainId', lastSelectedHotel.code); // restore last valid
            }else{
              setValue('chainId', getChainIdLS());
            }
          }}
          renderOption={(props, option) => {
            const hotelLabel = formatHotelDisplayName(option);
            const subtitle = getHotelBrandSubtitle(option);
            return (
              <li {...props} key={option.code}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      whiteSpace: "normal",
                      overflowWrap: "anywhere",
                      fontWeight: "normal",
                      fontSize: "14px",
                    }}
                  >
                    {hotelLabel}
                  </div>
                  <div
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      whiteSpace: "normal",
                      overflowWrap: "anywhere",
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "2px",
                    }}
                  >
                    {`(${subtitle})`}
                  </div>
                </div>
              </li>
            );
          }}
          componentsProps={{
            paper: {
              sx: { maxWidth: 360 },
            },
          }}
          disabled={disableHotel}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              className="select-project"
            />
          )}
        />

      )}
    />
  );
};

export default SelectHotel;
